type EventFields = {
  articleId?: string
  articleTitle?: string
  articleType?: string
  objectName: string
  title: string
}

export const ButtonTappedFields = ({
  articleId,
  articleTitle,
  articleType,
  objectName,
  title,
}: EventFields) => ({
  article_id: articleId,
  article_title: articleTitle,
  article_type: articleType,
  event_text: 'Button Tapped',
  event: 'button_tapped',
  object_name: objectName,
  screen_name: 'growArticle',
  screen: 'growArticle',
  title,
})
